import React, { useMemo } from 'react';
import { TrendingUp, PhoneCall, Share2, Headphones } from 'lucide-react';

const iconMap = {
  TrendingUp,
  PhoneCall,
  Share2,
  HeadphonesIcon: Headphones,
};

const IMPORT_SUBSTITUTION_SITUATION_NAME = 'импортозамещение';

export function sortSituationsForFilter(situations) {
  const list = [...situations];
  const priorityIndex = list.findIndex(
    (situation) => (situation.name || '').trim().toLowerCase() === IMPORT_SUBSTITUTION_SITUATION_NAME,
  );
  if (priorityIndex <= 0) return list;
  const [priorityItem] = list.splice(priorityIndex, 1);
  return [priorityItem, ...list];
}

const SituationFilter = ({ situations, activeFilter, onFilterChange }) => {
  const orderedSituations = useMemo(
    () => sortSituationsForFilter(situations),
    [situations],
  );

  return (
    <div className="mb-8">
      <h3 className="text-sm font-medium text-muted-foreground mb-4">Мне нужно:</h3>
      <div className="flex flex-col gap-2">
        <button
          onClick={() => onFilterChange(null)}
          className={`w-full text-left px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
            activeFilter === null
              ? 'bg-accent text-accent-foreground shadow-lg shadow-accent/20'
              : 'bg-white text-muted-foreground hover:bg-accent/5 hover:text-foreground'
          }`}
        >
          Все ситуации
        </button>
        {orderedSituations.map((situation) => {
          const IconComponent = iconMap[situation.icon] || TrendingUp;
          const isActive = activeFilter === situation.id;
          
          return (
            <button
              key={situation.id}
              onClick={() => onFilterChange(situation.id)}
              className={`w-full flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-accent text-accent-foreground shadow-lg shadow-accent/20'
                  : 'bg-white text-muted-foreground hover:bg-accent/5 hover:text-foreground'
              }`}
            >
              <IconComponent className="w-4 h-4 flex-shrink-0" />
              <span className="text-left">{situation.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SituationFilter;
